var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1869c27c351042f17a99cb6e2e6610b316f76960"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@everyonesocial"]={id:"1869c27c351042f17a99cb6e2e6610b316f76960"};
      